import React from "react";
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";
import App from "../pages/App";

function AppLayout(){
    return (
    <>
     <App />
    </>

    );
}

export default AppLayout;